<template>
    <div class="soc">
        <Echart :id="id" :options="options"></Echart>
    </div>
</template>

<script>
import Echart from '../../components/echarts.vue'
export default {
    components: { Echart },
    props: {
        id: {
            type: String,
            default: ''
        },
        licheng: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            options: {
                series: [{
                    type: 'gauge',
                    progress: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            width: 0
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        length: 0
                    },
                    axisLabel: {
                        fontSize: 0
                    },
                    anchor: {
                        show: true,
                        showAbove: true,
                        size: 10,
                        itemStyle: {
                            borderWidth: 5
                        }
                    },
                    title: {
                        show: false
                    },
                    detail: {
                        valueAnimation: true,
                        fontSize: 25,
                        formatter: '{value} 公里',
                        color: '#fff',
                        offsetCenter: [0, '120%']
                    },
                    data: [{
                        value: this.licheng
                    }]
                }]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.soc {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    background: url(~@/assets/images/energyMuseum/dashboard.png) center center no-repeat;
    background-size: 100% 100%;
    > div {
        width: 100%;
        height: 100%;
    }
}
</style>